import { render, staticRenderFns } from "./LeaderboardRanking.vue?vue&type=template&id=0641478b&scoped=true&"
import script from "./LeaderboardRanking.vue?vue&type=script&lang=js&"
export * from "./LeaderboardRanking.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardRanking.vue?vue&type=style&index=0&id=0641478b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0641478b",
  null
  
)

export default component.exports